module.exports = __webpack_public_path__ + "img/B0_Card.cebee050.png";